import { locationHubService } from '../../services/locationHubService.js';
import Alert from '../common/Alert.js';
import { downloadBlob } from '../../utils/downloadBlob.js';

export const downloadHubAttendanceQr = async (hub) => {
  if (!hub?.hub_id) return;
  if (hub.latitude == null || hub.longitude == null) {
    Alert.error('Set hub GPS coordinates before downloading the attendance QR');
    return;
  }
  try {
    const response = await locationHubService.downloadAttendanceQr(hub.hub_id);
    await downloadBlob(response.data, `${hub.hub_id}_attendance_qr.pdf`, 'application/pdf');
    Alert.success('Attendance QR downloaded (A5)');
  } catch (error) {
    let message = 'Failed to download attendance QR. Set hub GPS first.';
    const data = error.response?.data;
    if (typeof data?.error === 'string') {
      message = data.error;
    } else if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        if (parsed?.error) message = parsed.error;
      } catch {
        // ignore
      }
    } else if (data && typeof data.text === 'function') {
      try {
        const parsed = JSON.parse(await data.text());
        if (parsed?.error) message = parsed.error;
      } catch {
        // ignore
      }
    }
    Alert.error(message);
  }
};
